import { useQuery } from "@tanstack/react-query";
import { ToastService } from "@shared/lib/services";
import { useEffect } from "react";

import { BackednResponse } from "@shared/lib/types";
import { INFLUENCER_LIST_QUERY_KEY } from "../constants";
import { IInfluencerFacets } from "@shared/lib/types/influencer";
import { InfluencerService } from "../services/influencer.service";

export function useGetInfluencerFacets() {
  const { data, isLoading, isError, error } = useQuery<
    BackednResponse<IInfluencerFacets>
  >({
    queryKey: [...INFLUENCER_LIST_QUERY_KEY, "facets"],
    queryFn: () => InfluencerService.getInfluencerFacets(),
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    facets: data?.data || {},
    isError,
    isFetching: isLoading,
  };
}
